import { FC } from "react";
import { theme } from "tailwind.config";
import LogoImage from "@/assets/imgs/svg/logo-default.svg";

type Props = {
  width?: number;
  height?: number;
  black?: boolean;
};

const Logo: FC<Props> = ({ width, height, black = true }): JSX.Element => {
  return (
    <LogoImage
      width={width}
      height={height}
      fill={black ? theme.colors.brand.black : theme.colors.brand.white}
    />
  );
};
export default Logo;
